<template>
  <div class="company-introduction">
    <div class="intro-container">
      <p class="intro-text">
      台灣聯通停車場開發股份有限公司創立於民國81年元月，成長歷程可視為台灣停車產業從「單點經營」走向「連鎖化與科技化」的縮影，也因為廣泛的聚點及多元的信用卡優惠折抵，成為開車族群心目中的首選品牌。</p>
      <br>
      <p class="intro-text">面對智慧城市與綠能轉型的趨勢，台灣聯通陸續導入AI影像辨識、IoT技術與大數據分析，優化車位週轉率，開發更便捷的行動APP，提供即時車位查詢、無感支付及導航服務。另因應電動車普及逐步在既有場站增設充電樁，同時優化照明與通風系統，達成節能減碳目標。
      </p>
      <br>
      <p class="intro-text">
      未來，我們將致力於推動「智慧停車」轉型以提升營運效率，為「智慧城市」的發展貢獻一己之力，將傳統停車空間升級，融入更人性化的城市環境，讓顧客、員工與企業都能獲得利益。
      </p>
    </div>
  </div>
  <div style = "display:none">
    <button @click="openModal">Open Modal</button>
    <button @click="openSuccess">Open Success</button>
  </div>
</template>

<script>

export default {
  name: 'CompanyIntroduction',

  methods: {
    openModal() {
      this.$modal.showModal({
        component: 'CustomModalContent', // Specify the component to render
        props: { message: 'Hello from the modal!' }, // Props to pass to the component
        onClose: () => {
          console.log('Modal has been closed.');
        }
      });
    },
    openSuccess() {
      this.$modal.showModal({
        component: 'SuccessScreen',
        props: { message: 'Success!' },
        onClose: () => {
          console.log('Success screen has been closed.');
        }
      });
    }
  }
}
</script>

<style scoped>
.company-introduction {
  background-color: var(--green03);
  color: white;
  width: 100%;
  min-height: 632px;   /* 改這裡 */
  padding-bottom: 80px; /* 給底部一點空間 */
}

.intro-container {
  width: 1416px;
  /* align-items: left; */
  margin: 0 auto;
  padding-top: 144px;

  /* background-color:red; */
}

.intro-text {
  /* position: absolute; */
  width: 1176px;
  /* height: 256px; */
  top: 232px;
  left: 13%;
  /* gap: 0px; */
  /* opacity: 0px; */
  margin: 0px;
  /* text-align: center; */



  color: white;
  /* margin: 10% auto 5% auto; Center horizontally with top margin 30% and bottom margin 0 */

  /* //styleName: 6xl/bold; */
  font-family: Inter;
  font-size: 48px;
  font-weight: 700;
  line-height: 64.32px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;



}

@media (max-width: 560px) {
  .company-introduction {
    min-height: 424px;   /* 改成 min-height */
    padding-bottom: 40px; /* 底部留空間 */
    display: block;      /* 不要 flex */
  }

  .intro-container {
    width: 343px;
    margin: 0 auto;
    padding-top: 56px;
  }

  .intro-text {
    width: 100%;
    font-family: Inter;
    font-size: 24px;
    font-weight: 700;
    line-height: 33.6px;
    text-align: left;
    margin-bottom: 20px;  /* 取代 <br> */
  }

}

</style>
